import {metadaApi} from '@dms/api/base';

import {
  GetWarehouseDispensingUnitPresetsResponse,
  GetWarehouseDispensingUnitPresetsRequest,
  GetWarehouseDispensingUnitPresetsRequestSchema,
  GetWarehouseDispensingUnitPresetsResponseSchema,
  GetWarehouseDispensingUnitPresetResponse,
  GetWarehouseDispensingUnitPresetRequest,
  GetWarehouseDispensingUnitPresetRequestSchema,
  GetWarehouseDispensingUnitPresetResponseSchema,
  PostDispensingUnitPresetResponse,
  PostDispensingUnitPresetRequest,
  PostDispensingUnitPresetRequestSchema,
  PostDispensingUnitPresetResponseSchema,
  PatchDispensingUnitPresetResponse,
  PatchDispensingUnitPresetRequest,
  PatchDispensingUnitPresetRequestSchema,
  PatchDispensingUnitPresetResponseSchema,
  DeleteDispensingUnitPresetsResponse,
  DeleteDispensingUnitPresetsRequest,
  DeleteDispensingUnitPresetsRequestSchema,
  DeleteDispensingUnitPresetsResponseSchema,
} from './types';

export const metadaWarehouseDispensingUnitPresetApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getDispensingUnitPresets: build.query<
      GetWarehouseDispensingUnitPresetsResponse,
      GetWarehouseDispensingUnitPresetsRequest
    >({
      query: () => ({
        url: `core/v1/codelist/wrh-article-dispensing-unit-presets`,
        method: 'GET',
      }),
      providesTags: ['dispensingUnitPresets'],
      extraOptions: {
        requestSchema: GetWarehouseDispensingUnitPresetsRequestSchema,
        responseSchema: GetWarehouseDispensingUnitPresetsResponseSchema,
      },
    }),
    getDispensingUnitPreset: build.query<
      GetWarehouseDispensingUnitPresetResponse,
      GetWarehouseDispensingUnitPresetRequest
    >({
      query: (queryArg) => ({
        url: `core/v1/codelist/wrh-article-dispensing-unit-presets/${queryArg.codeListId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'dispensingUnitPresets', id: queryArg.codeListId},
      ],
      extraOptions: {
        requestSchema: GetWarehouseDispensingUnitPresetRequestSchema,
        responseSchema: GetWarehouseDispensingUnitPresetResponseSchema,
      },
    }),
    postDispensingUnitPreset: build.mutation<
      PostDispensingUnitPresetResponse,
      PostDispensingUnitPresetRequest
    >({
      query: (queryArg) => ({
        url: `core/v1/codelist/wrh-article-dispensing-unit-presets`,
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: ['dispensingUnitPresets'],
      extraOptions: {
        requestSchema: PostDispensingUnitPresetRequestSchema,
        responseSchema: PostDispensingUnitPresetResponseSchema,
      },
    }),
    patchDispensingUnitPreset: build.mutation<
      PatchDispensingUnitPresetResponse,
      PatchDispensingUnitPresetRequest
    >({
      query: (queryArg) => ({
        url: `core/v1/codelist/wrh-article-dispensing-unit-presets/${queryArg.codeListId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'dispensingUnitPresets', id: queryArg.codeListId},
      ],
      extraOptions: {
        requestSchema: PatchDispensingUnitPresetRequestSchema,
        responseSchema: PatchDispensingUnitPresetResponseSchema,
      },
    }),
    deleteDispensingUnitPresets: build.mutation<
      DeleteDispensingUnitPresetsResponse,
      DeleteDispensingUnitPresetsRequest
    >({
      query: (queryArg) => ({
        url: 'core/v1/codelist/wrh-article-dispensing-unit-presets/delete',
        method: 'POST',
        queryArg,
        body: queryArg,
      }),
      invalidatesTags: ['dispensingUnitPresets'],
      extraOptions: {
        requestSchema: DeleteDispensingUnitPresetsRequestSchema,
        responseSchema: DeleteDispensingUnitPresetsResponseSchema,
      },
    }),
  }),
});

export const {
  useGetDispensingUnitPresetsQuery,
  useGetDispensingUnitPresetQuery,
  usePostDispensingUnitPresetMutation,
  usePatchDispensingUnitPresetMutation,
  useDeleteDispensingUnitPresetsMutation,
} = metadaWarehouseDispensingUnitPresetApi;
